let json = function () {
    this.jsonClean = function (data) {
        return JSON.parse(JSON.stringify(data))
    }
}
export default json